import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import { transition, tabVariants, containerVariants, iconVariants, lineVariants } from './variants';
import styles from './Tabs.module.css';

export default function Tabs({ tab }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const ref = searchParams.get('ref');

    const handleTabs = (e) => {
        const tabName = e.currentTarget.id;
        setSearchParams({ tab: tabName, ref }, { replace: true });
    };

    return (
        <AnimatePresence mode='wait'>
            {tab && (
                <motion.div
                    className={styles.container}
                    variants={containerVariants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                >
                    <div className={styles.tabContainer}>
                        <motion.div
                            className={styles.tab}
                            transition={transition}
                            variants={tabVariants}
                            initial={false}
                            animate={tab === 'style' ? 'active' : 'inactive'}
                            whileHover={tab !== 'style' ? 'hover' : 'active'}
                            id='style'
                            onClick={handleTabs}
                        >
                            <motion.span
                                className={styles.icon}
                                transition={transition}
                                variants={iconVariants}
                                initial={false}
                                animate={tab === 'style' ? 'active' : 'inactive'}
                            >
                                <i className='far fa-palette' />
                            </motion.span>
                            Style
                            <motion.span
                                className={styles.line}
                                transition={transition}
                                variants={lineVariants}
                                initial={false}
                                animate={tab === 'style' ? 'active' : 'inactive'}
                            />
                        </motion.div>
                        <motion.div
                            className={styles.tab}
                            transition={transition}
                            variants={tabVariants}
                            initial={false}
                            animate={tab === 'frames' ? 'active' : 'inactive'}
                            whileHover={tab !== 'frames' ? 'hover' : 'active'}
                            id='frames'
                            onClick={handleTabs}
                        >
                            <motion.span
                                className={styles.icon}
                                transition={transition}
                                variants={iconVariants}
                                initial={false}
                                animate={tab === 'frames' ? 'active' : 'inactive'}
                            >
                                <i className='far fa-image' />
                            </motion.span>
                            Frames
                            <motion.span
                                className={styles.line}
                                transition={transition}
                                variants={lineVariants}
                                initial={false}
                                animate={tab === 'frames' ? 'active' : 'inactive'}
                            />
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
